export const scrollToFilterResults = (selector?: string) => {
	if (!selector) return;

	requestAnimationFrame(() => {
		const target = document.querySelector(selector);
		if (target && typeof target.scrollIntoView === 'function') {
			target.scrollIntoView({ block: 'start' });
		}
	});
};
